import React, { useState } from 'react';
import B2BApi from "../../B2bApi";
// import { useSelector } from 'react-redux';
import { t } from '../../content';
// import Form from '../../components/reusableElementsComponents/Form';
import Button from '../../components/reusableElementsComponents/Button';
import WriteAccessGuard from '../../components/reusableElementsComponents/WriteAccessGuard';
import MultiFactorAuthentication from '../../components/authentication/MultiFactorAuthentication';

import { ToastContainer, toast } from 'react-toastify';
import * as Constants from '../../constants';
import { FormControl, TextField, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function SecuritySettings({userRole}) {
    // const data = useSelector( state => state.contentfulData.all['change password']);

    const [password, setPassword] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);

    const [newPassword, setNewPassword] = useState("");
    const [newPasswordVisible, setNewPasswordVisible] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const [errors, setErrors] = useState({
        password: false,
        new_password: false,
        confirm_password: false
    });
    const [errorMessages, setErrorMessages] = useState({
        password: t('validation.invalidCurrentPassword'),
        new_password: "",
        confirm_password: t('validation.passwordMustBeSame')
    });

    const validateNewPassword = () => {
        if (!Constants.VALID_PASSWORD.test(newPassword)) {
            setErrors(prevErrors => ({
                ...prevErrors,
                new_password: true
            }));
            setErrorMessages(prevMessages => ({
                ...prevMessages,
                new_password: Constants.VALID_PASSWORD_INSTRUCTION
            }));
        }
        if (newPassword === password) {
            setErrors(prevErrors => ({
                ...prevErrors,
                new_password: true
            }));
            setErrorMessages(prevMessages => ({
                ...prevMessages,
                new_password: Constants.NO_PASSWORD_DUPLICATION_INSTRUCTION
            }));
        }
        if (Constants.VALID_PASSWORD.test(newPassword) && newPassword !== password) {
            setErrors(prevErrors => ({
                ...prevErrors,
                new_password: false
            }));
            setErrorMessages(prevMessages => ({
                ...prevMessages,
                new_password: ""
            }));
        }
    }

    const validateConfirmPassword = (value) => {
        if (newPassword !== value) {
            setErrors(prevErrors => ({
                ...prevErrors,
                confirm_password: true
            }));
            return false;
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                confirm_password: false
            }));
            return true;
        }
    }

    return (<>
            <div className='change-password-section wrapper-div'>
                <ToastContainer containerId="security-settings" autoClose={2000} />
                <div className="change-password-inner-div">
                    <h4>{t('account.changePassword')}</h4>
                    <FormControl style={{ width: "100%", marginBottom: "20px" }}>
                        <TextField
                            placeholder={t('common.placeholders.enterCurrentPassword')}
                            id="password"
                            name="password"
                            type={ passwordVisible ? "text" : "password"}
                            autoComplete="on"
                            value={password}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <button type="button" onClick={() => setPasswordVisible(!passwordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                            {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </button>
                                    </InputAdornment>
                                ),
                            }}
                            variant="standard"
                            onChange={(e) => {
                                setPassword(e.target.value)
                                setErrors(prevErrors => ({
                                    ...prevErrors,
                                    password: false
                                }));
                            }}
                        />
                    </FormControl>
                    {errors.password &&
                        <div>
                            <p style={{ color: "red" }}>{errorMessages.password}</p>
                        </div>
                    }
                    <br />
                    <FormControl style={{ width: "100%", marginBottom: "20px" }}>
                        <TextField
                            placeholder={t('common.placeholders.enterNewPassword')}
                            id="new_password"
                            name="new_password"
                            type={ newPasswordVisible ? "text" : "password"}
                            autoComplete="on"
                            value={newPassword}
                            onBlur={validateNewPassword}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <button type="button" onClick={() => setNewPasswordVisible(!newPasswordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                            {newPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </button>
                                    </InputAdornment>
                                ),
                            }}
                            variant="standard"
                            onChange={(e) => {
                                setNewPassword(e.target.value);
                                setErrors(prevErrors => ({
                                    ...prevErrors,
                                    new_password: false
                                }));
                            }}
                        />
                    </FormControl>
                    {errors.new_password &&
                        <div>
                            <p style={{ color: "red" }}>{errorMessages.new_password}</p>
                        </div>
                    }
                    <br />
                    <FormControl style={{width: "100%", marginBottom: "20px" }}>
                        <TextField
                            placeholder={t('common.placeholders.confirmPassword')}
                            id="confirm_password"
                            name="confirm_password"
                            type={ confirmPasswordVisible ? "text" : "password"}
                            autoComplete="on"
                            value={confirmPassword}
                            // onBlur={validateConfirmPassword}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <button type="button" onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                            {confirmPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </button>
                                    </InputAdornment>
                                ),
                            }}
                            variant="standard"
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                validateConfirmPassword(e.target.value);
                                // setErrors(prevErrors => ({
                                //     ...prevErrors,
                                //     confirm_password: false
                                // }));
                            }}
                        />
                    </FormControl>
                    {errors.confirm_password &&
                        <div>
                            <p style={{ color: "red" }}>{errorMessages.confirm_password}</p>
                        </div>
                    }
                    <br />
                    <div className='d-flex justify-content-center'>
                        <WriteAccessGuard>
                            {password && newPassword && confirmPassword && !errors.password && !errors.new_password && !errors.confirm_password ?
                                <Button btnstyle={'mazhrBtn default-green white'} onClick={onSubmit}>
                                    {t('account.changePassword')}
                                </Button>
                                :
                                <Button btnstyle={'mazhrBtn grey white'} disabled={true}>
                                    {t('account.changePassword')}
                                </Button>
                            }
                        </WriteAccessGuard>
                    </div>
                </div>
            </div>

            <MultiFactorAuthentication userRole={userRole} />
            
        </>)

    function onSubmit(e) {
        e.preventDefault();
        if (!password || !newPassword || !confirmPassword) {
            toast.error(t('validation.fillAllFields'), { containerId: 'security-settings', });
            return;
        }
        if (validateConfirmPassword(confirmPassword) === false) {
            toast.error(t('validation.passwordMismatch'), { containerId: 'security-settings', });
            return;
        }
        let obj = new B2BApi();
        obj.apiCall('user/password/','post',JSON.stringify({password:password,new_password:newPassword})).then(data => {
            if(data?.httpStatus === 200){
                setErrors({
                    password: false,
                    new_password: false,
                    confirm_password: false
                });
                toast.success(t('account.toasts.passwordUpdated'), { containerId: 'security-settings', });
            } else if(data?.json?.error && data?.json?.error?.code === 1002){
                setErrors(prevErrors => ({
                    ...prevErrors,
                    password: true
                }));
                toast.error(data?.json?.error?.msg || t('validation.invalidCurrentPassword'), { containerId: 'security-settings', });
            } else {
                toast.error(t('account.toasts.invalidValues'), { containerId: 'security-settings', });
                setErrors(prevErrors => ({
                    ...prevErrors,
                    new_password: true,
                    confirm_password: true
                }));
            }
            setPassword("");
            setPasswordVisible(false);
            setNewPassword("");
            setNewPasswordVisible(false);
            setConfirmPassword("");
            setConfirmPasswordVisible(false);
        });
    }
}
 
export default SecuritySettings;